// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import TypographyComponent from 'components/Typography/Typography';
import { pxToEm } from 'theme';

interface StatusContainerProps {
  bgColor: string;
  iconsColor: string;
  endIconSize: number;
}

export const ContentContainer = styled.div<StatusContainerProps>`
  height: 48px;
  width: 100%;
  background-color: ${(props) => props.bgColor};
  border-radius: ${pxToEm(24)};
  color: ${(props) => props.theme.palette.common.white};
  box-shadow: ${(props) => props.theme.shadows[3]};
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  & .startIcon {
    margin-left: ${pxToEm(4)};
    color: ${(props) => props.iconsColor};
    width: 1em;
  }
  & .endIcon {
    cursor: pointer;
    padding: 0;
    color: ${(props) => props.iconsColor};
    font-size: ${(props) => props.endIconSize}em;
  }
`;

export const TextBox = styled(TypographyComponent)`
  max-width: calc(70vw - 100px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.down('md')} {
    max-width: calc(90vw - 100px);
  }
`;
